import React from "react";
import styles from './layout.module.css';
import NavigationTabs from "../navigation/navigationTab/NavigationTabs";
import { SettingsProvider } from "../settings/Provider";
import useFeatureFlag from "@/hooks/useFeatureflag";

export default function SettingsLayout({ children }: { children: React.ReactNode }) {
  const launchSideBar = useFeatureFlag("newSideBar");
  
  return (
    <SettingsProvider>
      <div className={
        launchSideBar ? styles.containerMaxWidth : styles.container
      }>
        <NavigationTabs 
          tabs={[
            { id: 'profile', label: 'Profile', href: '/profile' },
            { id: 'team', label: 'Team', href: '/team' },
            { id: 'billing', label: 'Billing', href: '/billing' },
            // { id: 'billing-recurly', label: 'Billing Recurly', href: '/billing-recurly' },
          ]}
        />
        {children}
      </div>
    </SettingsProvider>
  );
}
